module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-186.2fc6a932.svg";